import { useEffect, useState } from "react";
import { _CompetitionType, _DocumentFactory, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _BankingConciliation, _BankingConciliationData, _CheckBanking, _StatementMovementCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { InputDate } from "../../../theme/Input/InputDate";
import { BankAccountSelect } from "../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { ConciliationStateConstantsselect } from "../BankingConciliation/BankingConciliationReport/ConciliationStateConstantsselect";

interface Props {
    idBankingStatement: number;
    BankingAccountParent?: any
}

export const StatementMovementCatalog = ({ idBankingStatement, BankingAccountParent }: Props) => {

    const BankingStatement = useDataBean(_StatementMovementCatalog);
    const single = Singleton.getInstance();
    const BankingConciliationData = useDataBean(_BankingConciliationData);
    const paginador = usePaginator();
    const paginador2 = usePaginator();
    const check = useDataBean(_CheckBanking);
    const [showtable, setshowtable] = useState<any>(null)
    const BankingConciliation = useDataBean(_BankingConciliation);
    const [docs, setDocs] = useState<any>([]);
    const [listaresult, setListaresult] = useState<any>([]);
    const [state, setstate] = useState<any>(null)
    const _documentos = useDataBean(_DocumentFactory);
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(null)
    const [show, setshow] = useState<any>(null)
    const [BankingAccount, setBankingAccount] = useState<number>(BankingAccountParent)
    const [listanueva, setListanueva] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [modalaccion, setModalaccion] = useState<any>({ tabIndex: -1, view: false, btnClose: false, btnSubmit: true, format: 'modal-lg' });
    const [IDtoBanking, setIDtoBanking] = useState<any>(null)
    const [modalconciliar, setModalconciliar] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    useEffect(() => {
        if (idBankingStatement)
            getLista();
    }, [idBankingStatement, paginador2.page])

    useEffect(() => {
        if (modaldoc.view) {
            verDocumentos();
        }
    }, [modaldoc.view]);

    useEffect(() => {
        if (IDtoBanking) {
            Datawhitid();
        }
    }, [IDtoBanking, paginador.page]);

    const getLista = () => {
        BankingStatement.instance.getBankingStatementMovementCatalog(idBankingStatement, null, paginador2.page, 15).then(
            (resp: any) => {

                paginador2.setPages(resp.NumberOfPages)

                let lista = resp.List;

                lista.forEach((user: any) => {
                    user.DataBeanProperties.Doc =
                        (user.DataBeanProperties.DocumentMnemonic ?? "") + "-" +
                        (user.DataBeanProperties.DocumentConsecutive ?? "") + "-" +
                        (user.DataBeanProperties.DocumentDate ?? "");
                });

                setLista(lista);
            }
        )
    }

    const getBankingConciliationyear = () => {

        BankingConciliation.instance.getBankingConciliationDatawhityear(BankingAccount, year, month).then(
            (resp: any) => {
                if (resp.IDBankingConciliation) {
                    console.log(resp);
                    setListanueva(resp)
                    setshow(true)
                    const id = resp.IDBankingConciliation; // ✅ Aquí obtienes el ID
                    console.log("IDBankingConciliation:", id); // 👈 Aquí lo ves en consola}
                    setIDtoBanking(id)
                }
            }
        )

    }
    const Datawhitid = () => {

        BankingConciliationData.instance.getBankingConciliationDatawhitid(IDtoBanking, stateR, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    setshowtable(true)
                    // setLista(resp.List)
                    // const datostrnas = resp.List;
                    const datostrnas = resp.List.map((user: any) => {
                        user.DataBeanProperties.Estado = estadoFechaManifiesto(user.DataBeanProperties.StateName);
                        return user;
                    });
                    setListaresult(datostrnas)

                }
            }
        );
    };
    const estadoFechaManifiesto = (Estado: any): string => {
        if (!Estado) return 'SIN ESTADO';


        let message = '';

        if (Estado === "PENDIENTE") {
            message = "<span class='text-warning'>PENDIENTE</span>";
        } else if (Estado === "CONCILIADO") {
            message = "<span class='text-success'>CONCILIADO</span>";
        }

        // message += ` (${Estado})`;
        return message;
    };
    const verDocumentos = () => {

        if (BankingStatement.bean.IDDocumentLocation) {
            _documentos.instance.getPdfAccountantDocument(BankingStatement.bean.IDDocumentLocation, null, BankingStatement.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);

                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const create = () => {
        BankingStatement.setBean({
            IDBankingStatement: idBankingStatement
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        BankingStatement.deleteItemVoid(BankingStatement.bean.IDBankingStatementMovement).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {

        BankingStatement.instance.updateBankingStatement(BankingStatement.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        });

    };
    const checkBankingConciliationData = () => {

        check.instance.checkBankingConciliationData(BankingConciliationData.bean.IDBankingConciliationData, true, BankingStatement.bean.IDBankingStatementMovement).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    setModalaccion({ ...modalaccion, "view": false });
                    Datawhitid();
                }
            }
        );
    };
    const head = [
        { title: 'ID', property: 'IDBankingStatementMovement', visible: true },
        { title: 'Fecha Movimiento', property: 'TrDate', visible: true },
        { title: 'Oficina', property: 'Office', visible: true },
        { title: 'Valor Movimiento', property: 'TrValue', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Referencia 1', property: 'TrRef1', visible: true },
        { title: 'Referencia 2', property: 'TrRef2', visible: true },
        { title: 'Referencia 3', property: 'TrRef3', visible: true },
        { title: 'ID Conciliación', property: 'IDBankingConciliation', visible: true },
        { title: 'Documento', property: 'Doc', visible: true },
        // { title: 'Fecha Documento', property: 'DocumentDate', visible: true },

    ]

    const headtwo = [
        { title: 'ID', property: 'IDBankingConciliationData', visible: true, mask: MASK_NUMBER },
        { title: 'Estado', property: 'Estado', visible: true },
        { title: 'Fecha', property: 'TrDate', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Saldo Débito', property: 'DebtValue', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Crédito', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        // { title: 'Fecha Documento', property: 'DocumentDate', visible: true },

    ]

    const cancelmov = () => {
        setModalaccion({ ...modalaccion, "view": false });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Conciliar Movimiento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalconciliar({ ...modalconciliar, "view": true }) } },
            { titulo: 'Documento Registro Contable', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModaldoc({ ...modaldoc, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [stateR, setStateR] = useState<number>();

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={BankingStatement.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} records={paginador2}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate name="TrDate" label="Fecha Movimiento" value={BankingStatement.bean.TrDate} setDate={(e) => BankingStatement.setBean({ ...BankingStatement.bean, "TrDate": e })} />
                        </div>
                        <div className="col-md-6">
                            <label>Oficina</label>
                            <input type="text" name="Office" className="form-control" value={BankingStatement.bean.Office} onChange={BankingStatement.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Valor Movimiento</label>
                            <input type="text" name="TrValue" className="form-control" value={BankingStatement.bean.TrValue} onChange={BankingStatement.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Referencia 1</label>
                            <input type="text" name="TrRef1" className="form-control" value={BankingStatement.bean.TrRef1} onChange={BankingStatement.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Referencia 2</label>
                            <input type="text" name="TrRef2" className="form-control" value={BankingStatement.bean.TrRef2} onChange={BankingStatement.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Referencia 3</label>
                            <input type="text" name="TrRef3" className="form-control" value={BankingStatement.bean.TrRef3} onChange={BankingStatement.handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={BankingStatement.bean.Description} onChange={BankingStatement.handleChange} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modaldoc} updateModal={setModaldoc}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docs}
                                IDDocument={BankingStatement.bean.DocumentLocation}
                                Since={BankingStatement.bean.DocumentDate}
                            />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalconciliar} updateModal={setModalconciliar}>
                    <div className="row">

                        <div className="col-md-3">
                            <BankAccountSelect label="Cuenta Bancaria" idSelector={BankingAccount} onChange={(e) => { setBankingAccount(e) }} />
                        </div>
                        <div className="col-md-3">
                            <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                        </div>
                        <div className="col-md-3">
                            <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                        </div>
                        <div className="col-md-3 mt-4 p-2">
                            <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getBankingConciliationyear}>
                                Buscar
                            </BasicButton>
                        </div>
                        {showtable && <>
                            <div className="row">
                                <label>Lista de transacciones a conciliar</label>
                                <div className="col-md-4">
                                    <ConciliationStateConstantsselect idSelector={stateR} onChange={(e) => { setStateR(e); }} />
                                </div>
                                <div className="col-md-2 mt-4 p-2">
                                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={Datawhitid}>
                                        Consultar
                                    </BasicButton>
                                </div>
                                <div className="col-md-12">
                                    <BasicTable body={listaresult} head={headtwo} rowSet={(e) => { BankingConciliationData.setBean(e); setModalaccion({ ...modalaccion, "view": true }); }} records={paginador} customRows={15}></BasicTable>
                                    <Modal modal={modalaccion} updateModal={setModalaccion} >
                                        <>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <strong>Desea Aplicar Movimineto ?</strong>
                                                </div>
                                                <div className="col-md-5">
                                                    <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-success btn-border" eventClick={checkBankingConciliationData}>
                                                        Aplicar Movimiento a Conciliación
                                                    </BasicButton>
                                                </div>
                                                <div className="col-md-4">
                                                    <BasicButton icon="ri-add-circle-line" clase="btn btn-soft-danger btn-border" eventClick={cancelmov}>
                                                        Cancelar Movimiento
                                                    </BasicButton>
                                                </div>
                                            </div>
                                        </>
                                    </Modal>
                                </div>
                            </div>
                        </>}

                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}